export default __webpack_public_path__ + "static/media/Engine Room_V.4.be3213bb.png";